// Mock data for the portfolio website

export const mockData = {
  profile: {
    name: "Sujay Babu Thota",
    initials: "Sujay",
    title: "Full-Stack Developer",
    tagline: "Turning Vision Into Reality With Code And Design.",
    description: "Highly driven Full Stack Developer with hands-on experience building production-ready web applications and AI-powered systems. Skilled in modern frameworks, scalable architectures and real-world deployments with a strong focus on problem-solving, rapid learning, and product-oriented development.",
    hireMeText: "Hire Me | Full Stack Developer | AI Enthusiast",
    email: "sujayss149@gmail.com",
    resume: "https://drive.google.com/file/d/1tc_gVLwUJ-35GduXwDmvwoDtLH_wgMec/view?usp=sharing",
    phone: "+91-9346491221"
  },
  
  socialLinks: {
    twitter: "https://twitter.com",
    github: "https://github.com/Sujay149/",
    linkedin: "https://www.linkedin.com/in/sujaybabu",
    pinterest: "https://pinterest.com",
    dribbble: "https://dribbble.com"
  },

  about: {
    bio: "Hi, I'm Sujay Babu Thota, a Full Stack Developer with hands-on experience building production-ready web applications and AI-powered systems. Currently pursuing B.Tech in Computer Science and Design at SRKR Engineering College, I specialize in modern frameworks, scalable architectures, and real-world deployments. I'm passionate about problem-solving, rapid learning, and product-oriented development. Whether it's building AI-powered healthcare assistants or full-stack e-commerce platforms, I bring my commitment to excellence and innovation to every project I work on.",
    skills: [
      "JavaScript", "TypeScript", "Python", "React.js", "Next.js",
      "Node.js", "Express.js", "MongoDB", "MySQL", "Firebase", "Supabase",
      "TailwindCSS", "HTML5", "CSS3", "Git", "Figma", "AI/ML"
    ],
    stats: [
      { value: "10+", label: "Projects Completed" },
      { value: "4+", label: "Client Projects" },
      { value: "1+", label: "Years Experience" }
    ],
    achievements: [
      {
        id: 1,
        title: "10+ Projects Delivered",
        description: "Successfully delivered production-ready applications across various domains",
        image: "achievements/proj-del.png",
        bgColor: "bg-gradient-to-br from-orange-50 to-purple-50 dark:from-orange-900/20 dark:to-purple-900/20",
      },
      {
        id: 2,
        title: "1+ Years of Experience as Software Developer",
        description: "Bringing hands-on expertise in modern web technologies and AI systems",
        image: "achievements/experience.png",
        bgColor: "bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-700",
      },
      {
        id: 3,
        title: "Full Stack Expertise",
        description: "Proficient in building scalable applications from frontend to backend and deployment",
        image: "achievements/fullstack.png",
        bgColor: "bg-gradient-to-br from-emerald-50 to-teal-50 dark:from-emerald-900/20 dark:to-teal-900/20",
      },
     {
  id: 4,
  title: "GDG On Campus Hackathon – Top 3",
  description:
    "Secured a Top 3 position among 50+ competing teams at the GDG On Campus Hackathon by delivering a high-impact, production-ready solution with strong technical execution and real-world applicability.",
  image:
    "achievements/gdg.png",
  bgColor:
    "bg-gradient-to-br from-indigo-50 to-purple-50 dark:from-indigo-900/20 dark:to-purple-900/20",
},

    ],
    experience: [
      {
        id: 1,
        title: "Junior Software Developer",
        company: "Techub",
        period: "Mar 2026 – Present",
        description: "Building mobile and web applications using React Native and modern JavaScript frameworks.",
        technologies: ["React Native", "JavaScript", "Web Applications"],
        achievements: [
          "Developing mobile and web applications using React Native and modern JavaScript frameworks.",
          "Contributing to production projects and strengthening skills in scalable system design.",
          "Working on full-cycle development from design to deployment."
        ],
        links: {
          live: "",
          github: ""
        }
      },
       {
        id: 2,
        title: "Fullstack Developer  Intern ",
        company: "Brandverse Technologies India Pvt. Ltd.",
        period: "July  2025 – Dec 2025",
        description: "E-commerce application with payments, order analytics and delivery workflow.",
        technologies: ["React.js", "Node.js", "Supabase", "Tailwind", "Razorpay"],
        achievements: [
          "Integrated JWT authentication, search features, OTP verification, and Razorpay payment processing.",
          "Built an admin dashboard with order analytics, delivery tracking, and status management.",
          "Designed geo-based delivery workflow improving assignment accuracy and turnaround efficiency."
        ],
        links: {
          live: "https://brandversetech.com/",
          // github: "https://github.com/Sujay149"
        }
      },
      {
        id: 3,
        title: "Fullstack Developer and Prompt Engineering Intern ",
        company: "Asvix",
        period: "Jun 2025 – Sep 2025",
        description: "AI-based healthcare assistant with medication guidance, reminders, and chat-based support.",
        technologies: ["TypeScript", "Next.js", "Tailwind", "Firebase", "AI/LLM"],
        achievements: [
          "AI-powered system development for prescription interpretation, symptom triage, and safe healthcare guidance.",
          "Skilled in modern web frameworks using TypeScript, Next.js, Tailwind CSS, and Firebase for scalable architectures.",
          "Real-world deployment implementing authentication, role-based access, real-time chat, and reminder systems.",
          "Strong foundation in applied LLM/NLP for medical-assistant conversations, knowledge retrieval, and responses."
        ],
        links: {
          live: "https://medibot-ai.com",
          github: "https://github.com/Sujay149"
        }
      },
     
      {
        id: 4,
        title: "Freelance Web Developer — WonderKids",
        company: "Freelance Project",
        period: "Oct 2024 – Dec 2024",
        description: "School platform enabling student–teacher information access and workflow management.",
        technologies: ["HTML", "CSS", "JavaScript", "PHP", "MySQL"],
        achievements: [
          "Built and deployed a school management platform actively used by teachers and students.",
          "Designed interactive dashboards and improved UI/UX for streamlined administrative workflows.",
          "Implemented secure authentication and role-based access control for data privacy and compliance."
        ],
        links: {
          live: "https://wonderkids.great-site.net/",
          github: "https://github.com/Sujay149"
        }
      }
    ],
    education: [
      {
        degree: "Bachelor of Technology in Computer Science and Design",
        institution: "SRKR Engineering College",
        location: "Bhimavaram",
        period: "2023 – 2026",
        details: "CGPA: 8.24"
      },
      {
        degree: "Diploma in Computer Science",
        institution: "Smt.B.Seetha Polytechnic",
        location: "Bhimavaram",
        period: "2020 – 2023",
        details: "Percentage: 78.31"
      }
    ]
  },

projects: [
  
  {
    id: 1,
    title: "Prompt2Code",
    category: "VS Code Extension",
    type: "fullstack",
    description:
      "Prompt-driven code generation and inline completions inside VS Code.",
    image:
      "/projects/Prompt2Code.png",
    tags: ["Typescript", "Node.Js", "Html","Css"],
    badge: null,
    github: "https://github.com/Sujay149/Prompt2Code.git",
    demo: "https://marketplace.visualstudio.com/items?itemName=SujayBabuThota.prompt2code",
  },
   {
    id: 2,
    title: "NeuroHub – Neurodiversity Support Platform",
    category: "Web Application",
    type: "fullstack",
    description:
      "A comprehensive support platform designed for individuals with ADHD, autism, and dyslexia. Features personalized learning modules and cognitive-friendly UI for enhanced accessibility.",
    image:
      "/projects/nuerohub.png",
    tags: ["Next.js", "Tailwind", "Firebase"],
    badge: null,
    github: "https://github.com/Sujay149/NUEROHUB",
    demo: "https://nuerohub.vercel.app/",
  },
  {
    id: 3,
    title: "Rofero – Full Stack E-Commerce Platform",
    category: "E-Commerce Platform",
    type: "fullstack",
    description:
      "Complete e-commerce solution with secure authentication, shopping cart, order management, wishlist, and integrated Razorpay payments with automated email notifications.",
    image:
      "/projects/rofero.png",
    tags: [
      "Next.js",
      "Node.js",
      "MongoDB",
      "Tailwind",
      "Razorpay",
      "Nodemailer",
    ],
    badge: null,
    github: "https://github.com/Sujay149/Rofero",
    demo: "https://clothingbrand-nu.vercel.app/",
  },
  {
  id: 4,
  title: "Sites60 – AI Website Builder",
  category: "AI WEB APPLICATION",
  type: "fullstack",
  description:
    "AI-powered website builder that turns natural-language prompts into real React + Vite projects with instant previews, iterative editing, publishing, and downloadable source code.",
  image: "/projects/sites60.png",
  tags: ["React", "Vite", "AI", "TypeScript", "Tailwind CSS", "Node.js"],
  badge: "In Progress",
  demo: "https://sites60-gilt.vercel.app/",
},
  {
    id: 5,
    title: "Slooze – Food Ordering System",
    type: "frontend",
    category: "Food Ordering Platform",
    description:
      "Enterprise-grade food ordering platform with Role-Based Access Control, JWT authentication, and multi-tenant data isolation. Features admin, manager, and member roles with country-based data segregation.",
    image:
      "/projects/slooze.png",
    tags: ["NestJS", "Next.js", "TypeScript", "JWT", "Passport.js", "Tailwind"],
    badge: null,
    github: "https://github.com/Sujay149/slooze-food-ordering-system",
    demo: "https://slooze-food-ordering-system.vercel.app/",
  },
  {
    id: 6,
    title: "Research & Startup Management System",
    type: "fullstack",
    category: "Enterprise Platform",
    description:
      "Enterprise platform for managing research projects, intellectual property rights, innovation initiatives, and startup ecosystems across Gujarat. Built for Smart India Hackathon.",
    image:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=500&fit=crop&q=80",
    tags: ["React.js", "Tailwind CSS", "Bootstrap", "Material UI", "MongoDB", "Node.js"],
    badge: "Hackathon",
    github: "https://github.com/Sujay149",
    demo: "https://innovationgujarat.vercel.app/",
  },
  {
    id: 7,
    title: "CodeDale – Website(Redesigned)",
    type: "frontend",
    category: "Web Application",
    description:
      "Professional corporate website showcasing technology solutions, services, client testimonials, and case studies with conversion-focused design.",
    image:
      "/projects/codedale.png",
    tags: ["Next.js", "React", "Vercel"],
    badge: null,
    github: "https://github.com/Sujay149/codedale-task",
    demo: "https://code-dale.vercel.app/",
  },
  {
    id: 8,
    title: "CraveFinder",
    type: "frontend",
    category: "Food Discovery App",
    description:
      "Modern food discovery platform to explore restaurants, cafes, and local eateries with intuitive navigation and seamless browsing experience.",
    image:
      "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800&h=500&fit=crop&q=80",
    tags: ["TypeScript", "React", "Node.js"],
    badge: null,
    github: "https://github.com/Sujay149",
    demo: "https://crave-finder.vercel.app/",
  }
]


  
};
